import React from 'react';
import ProtectedGymPanel from '../components/gym/ProtectedGymPanel';

const GymPage = () => {
    return <ProtectedGymPanel />;
};

export default GymPage;


